export enum PaymentTermType {
  IMMEDIATE = 'IMMEDIATE',
  NET_15 = 'NET_15',
  NET_30 = 'NET_30',
  NET_45 = 'NET_45',
  CUSTOM = 'CUSTOM',
}

export interface PaymentTermPreset {
  id: PaymentTermType;
  name: string;
  description: string;
  netDays: number;
  isDefault?: boolean;
}

export const PAYMENT_TERM_PRESETS: PaymentTermPreset[] = [
  {
    id: PaymentTermType.IMMEDIATE,
    name: 'Immediate',
    description: 'Payment due immediately upon receipt',
    netDays: 0,
  },
  {
    id: PaymentTermType.NET_15,
    name: 'NET 15',
    description: 'Payment due within 15 days',
    netDays: 15,
  },
  {
    id: PaymentTermType.NET_30,
    name: 'NET 30',
    description: 'Payment due within 30 days',
    netDays: 30,
    isDefault: true,
  },
  {
    id: PaymentTermType.NET_45,
    name: 'NET 45',
    description: 'Payment due within 45 days',
    netDays: 45,
  },
  {
    id: PaymentTermType.CUSTOM,
    name: 'Custom',
    description: 'Custom payment terms',
    netDays: 0,
  },
];

export const getPaymentTermPreset = (type: PaymentTermType): PaymentTermPreset | undefined => {
  return PAYMENT_TERM_PRESETS.find((preset) => preset.id === type);
};

export const getDefaultPaymentTermPreset = (): PaymentTermPreset => {
  return PAYMENT_TERM_PRESETS.find((preset) => preset.isDefault) || PAYMENT_TERM_PRESETS[2]; // Default to NET_30
};

export const calculateDueDate = (issueDate: Date, netDays: number): Date => {
  const dueDate = new Date(issueDate);
  dueDate.setDate(dueDate.getDate() + netDays);
  return dueDate;
};

export const validatePaymentTerms = (
  paymentTermType: PaymentTermType,
  customDays?: number
): { valid: boolean; error?: string } => {
  if (paymentTermType === PaymentTermType.CUSTOM) {
    if (customDays === undefined || customDays === null) {
      return { valid: false, error: 'Custom payment terms require days_until_due to be specified' };
    }
    if (customDays < 0) {
      return { valid: false, error: 'days_until_due cannot be negative' };
    }
    if (customDays > 365) {
      return { valid: false, error: 'days_until_due cannot exceed 365 days' };
    }
  }

  const preset = getPaymentTermPreset(paymentTermType);
  if (!preset) {
    return { valid: false, error: 'Invalid payment term type' };
  }

  return { valid: true };
};
